import $ from 'jquery';
import {biMarketingEventRunnerRun} from "../../services/bi/WithBiMarketingEventRunner";
import {MarketingEventTypeEnum} from "../../enums/MarketingEventTypeEnum";
import {MarketingEventVariableTypeEnum} from "../../enums/MarketingEventVariableTypeEnum";
import {CurrencyTypeEnum} from "../../enums/CurrencyTypeEnum";

const marketingEventViewListItemV1Semantics = {
    'mainWrapClass': 'marketing-event-view-list-item-v1',
    'instanceIdAttribute': 'data-instance-id',
    'isInitializedAttribute': 'data-is-initialized',
    'dataListNameAttribute': 'data-list-name',
};

/**
 * MarketingEventViewListItemV1 initializer
 */
$(function () {

    if ($(`.${marketingEventViewListItemV1Semantics.mainWrapClass}`).length === 0) {
        return false;
    }

    let marketingEventViewListItemV1 = new MarketingEventViewListItemV1();

    /**
     * Checking other instances
     */

    $(`.${marketingEventViewListItemV1Semantics.mainWrapClass}`).each((index, el) => {
        let objectElement = $(el);
        let isInitialized =
            ($(el).attr(`${marketingEventViewListItemV1Semantics.isInitializedAttribute}`) === 'true');
        if (!isInitialized) {
            marketingEventViewListItemV1.registerInstance(objectElement);
            marketingEventViewListItemV1.subscribe(objectElement);
        }
    });

});

class MarketingEventViewListItemV1
{
    // not install @babel/plugin-proposal-class-properties
    // init properties in constructor
    constructor() {
        this.pluginInstances = {};
    }

    /**
     * Register instance
     * @param JQuery element
     * @throws
     */
    registerInstance(el) {
        let instanceId =
            el.attr(`${marketingEventViewListItemV1Semantics.instanceIdAttribute}`) || false;

        if (instanceId === false) {
            throw new Error(`Invalid jQuery selector for ` +
                `instance slider with id [${instanceId}]`);
        }

        el.show();
        try {
            el.attr(`${marketingEventViewListItemV1Semantics.isInitializedAttribute}`, true);
            this.pluginInstances[instanceId] = el;
        } catch (e) {
            el.hide();
            throw e;
        }
    }

    /**
     * Subscribe instance
     * @param JQuery element
     * @throws
     */
    subscribe(el) {
        const productCategory = el.attr(`${marketingEventViewListItemV1Semantics.dataListNameAttribute}`)
        biMarketingEventRunnerRun({
            eventTypeId: MarketingEventTypeEnum.viewItemList,
            dynamicData: {
                [MarketingEventVariableTypeEnum.productCategory]: productCategory,
            }
        })
    }

}